export const URGENT_DAYS = 3;
export const WARNING_DAYS = 10;

export const daysUntil = (iso) => {
    if (!iso) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const target = new Date(iso);
    target.setHours(0, 0, 0, 0);
    return Math.round((target - today) / (1000 * 60 * 60 * 24));
};

/**
 * Returns null when there's no warning, otherwise:
 * { tone: 'warning' | 'danger', title, body, days }
 */
export const getSubscriptionAlert = (renewDate) => {
    const days = daysUntil(renewDate);
    if (days === null || days > WARNING_DAYS) return null;

    const isExpired = days < 0;
    const isUrgent = !isExpired && days <= URGENT_DAYS;
    const tone = isExpired || isUrgent ? "danger" : "warning";

    let title;
    if (isExpired) {
        title = "Your subscription has expired";
    } else if (days === 0) {
        title = "Your subscription expires today";
    } else if (days === 1) {
        title = "Your subscription expires tomorrow";
    } else {
        title = `Your subscription expires in ${days} days`;
    }

    const body = isExpired
        ? "Please contact your administrator to renew and restore access."
        : "Please contact your administrator to renew and avoid interruption.";

    return { tone, title, body, days };
};